import "@/themes/generated/theme.base.css";
import "@/themes/generated/theme.additional.css";
import "devextreme/dist/css/dx.common.css";
import 'vue-loading-overlay/dist/vue-loading.css';
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { SetupService } from "@questelservices/common";
import i18n from "./i18n";
import vuetify from "./plugins/vuetify";
import moment from "moment";
import VueMoment from "vue-moment";
import FlagIcon from 'vue-flag-icon';
import Loading from 'vue-loading-overlay';
import '@/style/main.scss';
import './filters/filters';

Vue.use(FlagIcon);
Vue.use(VueMoment, { moment });
Vue.config.productionTip = false;
Vue.use(Loading, { color: '#2850A0'});

(async () => {
  await new SetupService(store).initializeApp();

  new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App)
  }).$mount("#app");

})();
